import React, { Component } from 'react'
import FixedView from '../FixedView'
import { checkTranslation, translate } from '../../utils/useful'
import IntractionActionsList from '../IntractionActionsList'
import Collapsible from 'react-collapsible'

export default class BookingFrame extends Component {
    state = {
        header: [

            { name: "{{lang}}bookingframe.Services", img: '/assets/icons/applets/general/play-games.png', key: 'Services' },
            { name: "{{lang}}bookingframe.Provider", img: '/assets/icons/applets/general/pic.png', key: 'Provider' },
            { name: "{{lang}}bookingframe.Report", img: '/assets/icons/applets/general/watch.png', key: 'Report' },
            { name: "{{lang}}bookingframe.Clients", img: '/assets/icons/applets/general/news-feed.png', key: 'Clients' },
        ],
    }
    changeCollapsepage = () => {
        let page = this.state.page
        this.setState({ page: !page })
    }
    changeCollapsemanage = () => {
        let manage = this.state.manage
        this.setState({ manage: !manage })
    }
    render() {
        return (
            <div>
                <button onClick={() => this.framesOptionsList.showView()} ref={el => this.framesNode = el} className='flexc mrd-2'>
                    <div className='flexcc pld-3 prd-4 py-1 br-5 dark-blur-bg'>
                        <div className='flexcc mrd-1'>
                            <img className={this.props.invert ? 'invert' : ''} width={18} src="/assets/icons/applets/database/frame-white.svg" />
                        </div>
                        <p className='font-size-14 ' style={{ color: '#fff' }}>{this.props.currentFrame?.name ?? translate('bookingframe.Frames')}</p>
                    </div>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.framesOptionsList = el} nodeRef={this.framesNode} xOffset={-9} bottomOffset={27} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3  ' >
                        <div className='p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                            <div className=' mb-2'>
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}bookingframe.Pin Frames", icon: "/assets/icons/applets/database/pin-purple.svg" }} />
                            </div>
                            <div className='white-bg py-2 ' style={{ borderTop: '1px solid #eee', borderBottom: '1px solid #eee', }}>
                                <button className='flexcb p-2 w-100 hover-gray br-10' onClick={() => this.changeCollapsepage()} >
                                    <div className='flexc'>
                                        <img className='mrd-2 flexcc' width={18} src='/assets/icons/applets/database/stages-purple.svg' />
                                        <p className='main-c3'>{translate('bookingframe.Pages')}</p>
                                    </div>
                                    <button>
                                        <img width={22} className={'flexcc transition ' + (this.state.page ? 'rotate-180' : '')} src='/assets/icons/applets/database/arrow-up-purple.svg' />
                                    </button>
                                </button>
                                <Collapsible open={this.state.page} transitionTime={100}>
                                    <div className='py-2'>
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}bookingframe.Reservations", icon: "/assets/icons/applets/database/pages-purple.svg" }} />
                                    </div>
                                </Collapsible>
                            </div>
                            <div className='white-bg py-2 ' style={{ borderBottom: '1px solid #eee', }}>
                                <button className='flexcb p-2 w-100 hover-gray br-10' onClick={() => this.changeCollapsemanage()} >
                                    <div className='flexc'>
                                        <img className='mrd-2 flexcc' width={18} src='/assets/icons/applets/database/stages-purple.svg' />
                                        <p className='main-c3'>{translate('bookingframe.Manage')}</p>
                                    </div>
                                    <button>
                                        <img width={22} className={'flexcc transition ' + (this.state.manage ? 'rotate-180' : '')} src='/assets/icons/applets/database/arrow-up-purple.svg' />
                                    </button>
                                </button>
                                <Collapsible open={this.state.manage} transitionTime={100}>
                                    <div className='py-2'>
                                        <div className="">
                                            {this.state.header.map((prop, index) => {
                                                return (
                                                    <button onClick={() => this.props.setData('tabIndex', prop.key)} className="flexc p-2 br-5 hover-gray3 w-100" style={this.props.tabIndex == prop.name ? { backgroundColor: '#E5E5EA' } : {}}>
                                                        <img className="mrd-2" width={18} src={prop.img} alt="icon" />
                                                        <p className="main-c3 font-size-12">{checkTranslation(prop.name)}</p>
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </Collapsible>
                            </div>
                            <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}bookingframe.User Prespective", icon: "/assets/icons/applets/database/user.svg" }} />
                            <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}bookingframe.Main View", icon: "/assets/icons/applets/database/user.svg" }} />
                        </div>
                    </div >
                </FixedView >
            </div >
        )
    }
}
